function u(t) {
  var n = Math.random() + 1, o = t.minTimeout, a = o === void 0 ? 500 : o, i = t.factor, e = i === void 0 ? 2 : i, f = t.attempt, m = t.maxTimeout, r = m === void 0 ? 1 / 0 : m;
  return Math.min(n * a * Math.pow(e, f), r);
}
export {
  u as backoff
};
//# sourceMappingURL=index93.js.map
